module.exports = __webpack_public_path__ + "static/media/whiteLogo-alt.bce1e63b.png";